module.exports = __webpack_public_path__ + "img/sld_ch_11_t1_green.c00bdfa2.svg";